import { reducerRegistry } from 'reducer-registry'

const { createSlice } = require('@reduxjs/toolkit')

const initialState = {
  open: false,
  name: '',
  onAgree: null
}

const slice = createSlice({
  name: 'userAgreement',
  initialState,
  reducers: {
    openUserAgreementPopup: (state, { payload }) => {
      state.open = true
      state.onAgree = payload.onAgree
      state.name = payload.name
    },
    closeUserAgreementPopup: (state) => {
      state.open = false
      state.onAgree = null
      state.name = ''
    },
  }
})

reducerRegistry.add('userAgreement', slice.reducer)

export const {
  actions: {
    openUserAgreementPopup,
    closeUserAgreementPopup
  }
} = slice
